if (!customElements.get("custom-sort")) {
    customElements.define(
        "custom-sort",
        class CustomSort extends HTMLElement {
            constructor() {
                super();
                this.orderField = this.getAttribute("sort-field");
                this.initSection();
            }
            connectedCallback() {
                this.addEventListener("initSection", this.initSection);
            }
            disconnectedCallback() {
                this.removeEventListener("initSection", this.initSection);
            }
            initSection() {
                const list = Array.from(
                    this.querySelectorAll(`[${this.orderField}]`),
                );

                if (list.length > 0) {
                    list.sort(
                        (a, b) =>
                            Number(a.getAttribute(this.orderField)) -
                            Number(b.getAttribute(this.orderField)),
                    );
                    list.forEach((item) => this.appendChild(item));
                }
            }
        },
    );
}
